import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Spinner = styled.div`
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: var(--primary, #09f);
  border-radius: 50%;
  width: ${({ size }) => size || '36px'};
  height: ${({ size }) => size || '36px'};
  animation: ${spin} 1s linear infinite;
`;
